import { createFileRoute, redirect } from "@tanstack/react-router"

// Kommunikation is split into subsections; older links to the page itself
// land on the first one.
export const Route = createFileRoute("/(app)/_auth/settings/communication/")({
  beforeLoad: () => {
    throw redirect({
      to: "/settings/communication/notifications",
      replace: true,
    })
  },
})
